<template>
	<div class="overlay-std default-hidden" :class="{ 'visible': expanded && !loaded }">
		<div class="flex-container">
			<div>
				<div class="loader-inner ball-pulse-sync">
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
		</div>
	</div>
	<div class="race align-middle" :class="class" @click.prevent="toggleExpand">
		<div class="indicators">
			<div>
				<span class="blue indicator" v-if="race.signature"></span>
				<span class="purple indicator" v-if="race.breeders_cup"></span>
				<span class="red indicator" v-if="race.triple_crown"></span>
			</div>
		</div>
		<a :href="race.url" class="image-link">
			<img v-if="race.image.file" :src="race.image.file.styles.small_thumbnail_16_9"
			     :alt="race.title" class="show-for-medium"/>
			<img v-if="!race.image.file && race.track.image.file" :src="race.track.image.file.styles.small_thumbnail_16_9"
			     :alt="race.title" class="show-for-medium"/>
		</a>
		<div class="name">
			<strong class="serif"><a :href="race.url">{{ race.race_name }}</a></strong><br />
			<a :href="race.track.url" class="sub">{{ race.track.title }}</a>
		</div>
		<div class="post-time text-right" v-if="race.post_time && race.field_status != '3' && race.field_status != '4'">
			<strong class="serif" title="Note: This is not the TV start time.">{{ time }} </strong><br/>
			<span class="inactive sub">{{ broadcaster }}</span>
		</div>
    <div class="post-time text-right" v-if="race.field_status == '4'">
			<strong class="serif" title="Note: This race has been canceled.">CANCELED</strong><br/>
		</div>
	</div>
	<template v-if="expanded && race.field_status != '0'">
		<div class="race-expanded" v-show="loaded" transition="expand">
			<race-entries @async-data="setLoaded" :race="race"
			              v-if="race.field_status == '1' || race.field_status == '2' || race.field_status == '4'"></race-entries>
			<race-results @async-data="setLoaded" v-ref:results :race="race" v-if="race.field_status == '3'"></race-results>
		</div>
	</template>
</template>

<script>
	import moment from 'moment-timezone'
  moment.tz.setDefault('America/New_York')
	import _ from 'underscore'
	import RaceEntries from './RaceEntries.vue'
	import RaceResults from './RaceResults.vue'
	import Vue from 'vue'
	export default {
		components: { RaceEntries, RaceResults },
		props: [ 'race' ],
		data () {
			return {
				expanded: false,
				loaded: false
			}
		},
		computed: {
			time () {
				return moment(this.race.post_time).tz("America/New_York").format('h:mm A z');
			},
			broadcaster () {
				return _.map(this.race.broadcaster, function (item) {
					return item.title;
				}).join(', ');
			},
			class () {
				var classes = [];
				if (this.race.field_status != '0') classes.push('expandable');

				return classes;
			}
		},
		methods: {
			toggleExpand: function () {
				if (typeof(this.race.field_status) === 'undefined' || this.race.field_status === '0') {
					// Redirect the user to the race.
					window.location = this.race.url;
					return;
				}
				this.expanded = !this.expanded;
				this.loaded = false;
			},
			setLoaded: function () {
				this.loaded = true;
			},
			replay: function () {
				this.expanded = true;
				if (this.loaded) {
					this.setLoaded();
				}
			}
		},
		watch: {
			expanded: function () {
			  //removed JW player reference
			}
		}
	}
</script>



/** WEBPACK FOOTER **
 ** Race.vue?d63f6368
 **/